import { RecordCreateScreen } from "@/lib/Components/Screens/RecordScreen/RecordCreateScreen";
import { RecordCreateCard } from "@/lib/Components/SideBarList/Cards/RecordCreateCard";
import { CreateInvoiceInput, TaxType } from "@/gql/graphql";
import { useNavigate } from "@tanstack/react-router";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createInvoiceMutation } from "@/app/Invoices/GraphQL/invoiceMutations";
import { InvoiceCreateForm } from "@/app/Invoices/Components/Forms/InvoiceCreateForm";

export function InvoiceCreateScreen() {
  const { mutateAsync } = useGqlMutation(createInvoiceMutation);
  const navigate = useNavigate();

  return (
    <RecordCreateScreen>
      <RecordCreateCard<CreateInvoiceInput>
        title="Create an invoice"
        onSubmit={async (values) => {
          const invoice = await mutateAsync({
            input: values,
          });

          await navigate({
            to: "/$tenant/$orgId/supplier/{-$supplierId}/invoices/$id",
            params: (prev) => ({
              ...prev,
              id: invoice.createInvoice.id,
            }),
          });
        }}
        initialValues={{
          payee: null!,
          currency: null!,
          is_tax_included: false,
          purchase_order_number: "",
          lineItems: {
            upsert: [
              {
                quantity: 1,
                unit_amount: null!,
                tax_type: TaxType.NoGst,
                description: "",
              },
            ],
          },
        }}
      >
        <InvoiceCreateForm />
      </RecordCreateCard>
    </RecordCreateScreen>
  );
}
